angular.module('bribac.views.singleIbac', [
  'ngRoute',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.components.ibacBatteryDetails',
  'bribac.components.whenLoaded'
])

.config(function(
  $routeProvider
) {
  $routeProvider.when('/ibac/:id', {
    templateUrl: 'single-ibac-view.html',
    controller: 'SingleIbacViewCtrl',
    controllerAs: '$ctrl',
    resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
  })
})

.controller('SingleIbacViewCtrl', function(
  $translate,
  $window,
  $routeParams,
  KINDS,
  api,
  permissions
) {

  var $ctrl = this

  var ibacId = parseInt($routeParams.id)

  $ctrl.permissions = permissions
  if (!isFinite(ibacId)) {
    // TODO: Should show 404 error instead. Should probably do this check in the $routeProvider config.
    return
  }

  $ctrl.viewPromise = api.getView('ibac', ibacId).then(function(request) {
    $ctrl.ibac = request.data
  })

  $ctrl.getLocationMapLinkUrl = function() {
    var location = $ctrl.ibac.lastLocation
    return 'https://www.google.com/maps?q=' + location.latitude + ',' + location.longitude + '&hl=' + $translate.use()
  }

  $ctrl.getLocationMapImageUrl = function() {
    var location = $ctrl.ibac.lastLocation

    var url = 'https://maps.googleapis.com/maps/api/staticmap' +
      '?key=AIzaSyB7jDOsND9TEhHYtPgmDabxwt_4oN5t0Hw' +
      '&maptype=roadmap' +
      '&size=640x512' +
      '&language=' + $translate.use() +
      '&scale=' + ($window.devicePixelRatio > 1 ? 2 : 1) +
      '&markers=color: green' +
      '|label:I|' + location.latitude + ',' + location.longitude

    return url.replace('|', '%7C')
  }

  $ctrl.activation = function() {
    if ($ctrl.activating) {
      return
    }

    $ctrl.activating = true
    $ctrl.immediateTestSuccessI18n = ''

    var data = angular.extend({}, $ctrl.ibac);
    data.isLocked = !$ctrl.ibac.isLocked

    api['put'](KINDS.IBAC, data)
      .finally(function() {
        $ctrl.activating = false
      })
      .then(
        function success(request) {
          getIbacView()
        },
        function error(request) {
          $ctrl.activationErrorI18n = (request.data && request.data.errorMessage)
            ? request.data.errorMessage
            : (request.statusText || 'Unknown error')
        }
      )
  }

  function getIbacView() {
    api.getView('ibac', ibacId).then(function(request) {
      $ctrl.ibac = request.data
    })
  }
})
